import { useState } from 'react';
import { MagnifyingGlassIcon, Cross1Icon } from '@radix-ui/react-icons';
import Button from '@aura-design/system/button';
import Modal from '@aura-design/system/modal';

import SearchInput from '@/components/SearchInput';

type SearchNavProps = {
  isMobile?: boolean;
};

const SearchNav = ({ isMobile }: SearchNavProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (isMobile) {
    return (
      <div className={isOpen ? "" : "mr-1.5"}>
        {!isOpen ? (
          <Button mode="menu" onClick={() => setIsOpen(true)} isFluid>
            <MagnifyingGlassIcon />
            <span className="ml-2">Buscar</span>
          </Button>
        ) : (
          <div className="relative">
            <div className="absolute right-0 top-1 z-10">
              <Button mode="link" onClick={() => setIsOpen(false)}>
                <Cross1Icon />
              </Button>
            </div>
            <SearchInput onClose={() => setIsOpen(false)} />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <Modal
        isVisible={isOpen}
        onClose={() => setIsOpen(false)}
        classNameMod="fluid"
      >
        <div className="mt-2">
          <SearchInput onClose={() => setIsOpen(false)} />
        </div>
      </Modal>
      <Button
        mode="menu"
        className="white-text"
        onClick={() => setIsOpen(true)}
      >
        <MagnifyingGlassIcon />
      </Button>
    </>
  );
};

export default SearchNav;
